import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "register-page" }
const _hoisted_2 = { class: "page-header" }
const _hoisted_3 = { class: "page-content" }
const _hoisted_4 = { class: "tab-header" }
const _hoisted_5 = { class: "tab-content" }

import { computed, onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";
import store from "@/store";

import { maskCurrency } from "@/common/utils/mask";
import { toast } from "@/common/utils/toast";

import { termList, termCreate, termDelete } from "@/common/api/rest/term/term";

import type { TermType, TermPayloadType } from "@/common/types/term/term";

import {
	breadcrumbSimple,
	baseConfirm,
	baseModal,
	baseTable,
	svgIcon,
} from "@/common/components";

import FormTerm from "@/components/forms/form-term.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const { t, tm } = useI18n();
const router = useRouter();

const tableData = ref<TermType[]>([]);
const payload = ref<TermPayloadType | null>(null);

const selected = ref<TermType | null>(null);

const limit = ref<number>(6);
const page = ref<number>(0);
const pages = ref<number>(0);
const search = ref<string>("");
const searched = ref<number>(0);
const total = ref<number>(0);

const showModalAdd = ref(false);
const showModalDel = ref(false);
const payloadValid = ref(false);
const loading = ref(false);

const tableHeader = computed(() => [
	{ key: "name", label: t("common.labels.name") },
	{ key: "code", label: t("common.labels.code") },
	{ key: "status", label: t("common.labels.status") },
]);

const breadcrumbList = computed(() => [
	{
		key: "register",
		label: t("common.labels.registrations"),
		url: "/register",
	},
	{
		key: "terms",
		label: t("common.labels.terms"),
		url: "/register/term",
	},
]);

const statusOptions = computed(() => ({
	ACTIVE: t("common.labels.active"),
	INACTIVE: t("common.labels.inactive"),
}));

function fetchData() {
	loading.value = true;

	termList({
		page: page.value,
		limit: limit.value,
		search: search.value,
	})
		.then((response) => {
			const { success, data, message } = response;
			if (success) {
				tableData.value = data.list?.map((item: TermType) => {
					return {
						...item,
					};
				});
				pages.value = data.infos.pages;
				total.value = data.infos.total;
				searched.value = data.infos.count;
			} else {
				toast({ message: message, type: "error" });
			}
		})
		.catch(() => {
			toast({ message: t("error.default"), type: "error" });
		})
		.finally(() => {
			loading.value = false;
		});
}

function changePage(value: number) {
	page.value = value;
	fetchData();
}

function searchItem(value: string) {
	search.value = value;

	fetchData();
}

function addItem() {
	showModalAdd.value = true;
}

function addItemCancel() {
	showModalAdd.value = false;
	payload.value = null;
}

function addItemConfirm() {
	if (!payload.value) return;

	store.commit("SET_LOADING", true);

	termCreate(payload.value)
		.then((response) => {
			const { success, data, message } = response;

			if (success) {
				editItem(data);
				toast({ message: message, type: "success" });
			} else {
				toast({ message: message, type: "error" });
			}
		})
		.catch(() => {
			toast({ message: t("error.default"), type: "error" });
		})
		.finally(() => {
			store.commit("SET_LOADING", false);
		});
}

function editItem(data: TermType) {
	router.push(`/register/term/${data.term_id}/edit`);
}

function removeItem(data: TermType) {
	selected.value = data;
	showModalDel.value = true;
}

function removeItemCancel() {
	showModalDel.value = false;
	selected.value = null;
}

function removeItemConfirm() {
	if (!selected.value) return;

	termDelete(selected.value.term_id)
		.then((response) => {
			const { success, message } = response;

			fetchData();
			removeItemCancel();
			toast({ message: message, type: success ? "success" : "error" });
		})
		.catch(() => {
			toast({ message: t("error.default"), type: "error" });
		})
		.finally(() => {
			store.commit("SET_LOADING", false);
		});
}

function formatCurrency(value: number, currency: any) {
	const price = Number.parseFloat(value?.toString()).toFixed(2);
	return maskCurrency(price, currency);
}

onMounted(() => {
	fetchData();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("article", _hoisted_1, [
      _createElementVNode("section", _hoisted_2, [
        _createVNode(_unref(breadcrumbSimple), {
          items: breadcrumbList.value,
          "show-home": true,
          "url-home": "/home",
          active: "terms"
        }, null, 8, ["items"])
      ]),
      _createElementVNode("section", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_unref(svgIcon), {
            icon: "no-image",
            size: "2rem"
          }),
          _createTextVNode(" " + _toDisplayString(_unref(t)("common.labels.terms")), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_unref(baseTable), {
            header: tableHeader.value,
            data: tableData.value,
            limit: limit.value,
            page: page.value,
            pages: pages.value,
            total: total.value,
            searched: searched.value,
            loading: loading.value,
            options: true,
            del: true,
            edit: true,
            "onChange:page": _cache[0] || (_cache[0] = ($event: any) => (changePage($event))),
            onSearching: _cache[1] || (_cache[1] = ($event: any) => (searchItem($event))),
            "onBtn:add": _cache[2] || (_cache[2] = ($event: any) => (addItem())),
            "onBtn:edit": _cache[3] || (_cache[3] = ($event: any) => (editItem($event))),
            "onBtn:del": _cache[4] || (_cache[4] = ($event: any) => (removeItem($event)))
          }, {
            status: _withCtx(({ data }) => [
              _createTextVNode(_toDisplayString(statusOptions.value[data.status]), 1)
            ]),
            _: 1
          }, 8, ["header", "data", "limit", "page", "pages", "total", "searched", "loading"])
        ])
      ])
    ]),
    _createVNode(_unref(baseModal), {
      "button-confirm": _unref(t)('common.labels.save'),
      "button-close": _unref(t)('common.labels.cancel'),
      title: _unref(t)('term.modals.titles.term_add').toUpperCase(),
      show: showModalAdd.value,
      "show-button-confirm": true,
      onClose: _cache[7] || (_cache[7] = ($event: any) => (addItemCancel())),
      onConfirm: _cache[8] || (_cache[8] = ($event: any) => (addItemConfirm()))
    }, {
      content: _withCtx(() => [
        _createVNode(FormTerm, {
          data: selected.value,
          "onUpdate:data": _cache[5] || (_cache[5] = ($event: any) => (payload.value = $event)),
          onValidate: _cache[6] || (_cache[6] = ($event: any) => (payloadValid.value = $event))
        }, null, 8, ["data"])
      ]),
      _: 1
    }, 8, ["button-confirm", "button-close", "title", "show"]),
    _createVNode(_unref(baseConfirm), {
      show: showModalDel.value,
      title: _unref(t)('term.modals.titles.term_remove').toUpperCase(),
      message: 
			_unref(t)('term.modals.messages.term_remove', {
				name: selected.value?.name?.toUpperCase(),
			})
		,
      onCancel: _cache[9] || (_cache[9] = ($event: any) => (removeItemCancel())),
      onConfirm: _cache[10] || (_cache[10] = ($event: any) => (removeItemConfirm()))
    }, null, 8, ["show", "title", "message"])
  ], 64))
}
}

})